/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Clean_Zone_LabelInputs */

const en_dispatch_clean_zone_label = /** @type {(inputs: Dispatch_Clean_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone`)
};

const fr_dispatch_clean_zone_label = /** @type {(inputs: Dispatch_Clean_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone`)
};

const ms_sg2_dispatch_clean_zone_label = /** @type {(inputs: Dispatch_Clean_Zone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zon`)
};

/**
* | output |
* | --- |
* | "Zone" |
*
* @param {Dispatch_Clean_Zone_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_clean_zone_label = /** @type {((inputs?: Dispatch_Clean_Zone_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Clean_Zone_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_clean_zone_label(inputs)
	if (locale === "fr") return fr_dispatch_clean_zone_label(inputs)
	return ms_sg2_dispatch_clean_zone_label(inputs)
});